import React, { useState, useEffect, useCallback } from 'react';
import { ChefHat, UtensilsCrossed, ClipboardList, AlertCircle } from 'lucide-react';
import AdminMenus from './AdminMenus';
import EmpleadoMenu from './EmpleadoMenu';
import ReporteCafeteria from './ReporteCafeteria';
import { getMenus } from '../../api/cafeteria';
import { usePermissionsContext } from '../../contexts/PermissionsContext';

const TABS_ADMIN = [
  { id: 'admin',    label: 'Gestión', icon: ChefHat },
  { id: 'empleado', label: 'Mi Menú', icon: UtensilsCrossed },
  { id: 'reporte',  label: 'Reporte', icon: ClipboardList },
];

const TABS_EMPLEADO = [
  { id: 'empleado', label: 'Mi Menú', icon: UtensilsCrossed },
];

export default function CafeteriaModule({ currentUser }) {
  const { can } = usePermissionsContext();
  const esAdmin = can('CAFETERIA_MANAGE');
  const tabs    = esAdmin ? TABS_ADMIN : TABS_EMPLEADO;

  const [tab,     setTab]    = useState(esAdmin ? 'admin' : 'empleado');
  const [menus,   setMenus]  = useState([]);
  const [loading, setLoading] = useState(esAdmin);
  const [error,   setError]  = useState(null);

  const loadMenus = useCallback(async () => {
    if (!esAdmin) return;
    try {
      setLoading(true);
      setError(null);
      const data = await getMenus();
      setMenus(data.menus || []);
    } catch (e) {
      setError(e.response?.data?.error || 'Error al cargar menús');
    } finally {
      setLoading(false);
    }
  }, [esAdmin]);

  useEffect(() => { loadMenus(); }, [loadMenus]);

  return (
    <div className="space-y-4">

      {/* ── Tabs ─────────────────────────────────────────────────── */}
      <div className="border-b border-gray-200">
        <nav className="flex gap-1">
          {tabs.map(({ id, label, icon: Icon }) => (
            <button
              key={id}
              onClick={() => setTab(id)}
              className={`flex items-center gap-2 px-4 py-3 text-sm font-semibold border-b-2 transition-colors ${
                tab === id
                  ? 'border-blue-600 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              <Icon size={14} />
              {label}
            </button>
          ))}
        </nav>
      </div>

      {/* ── Content ──────────────────────────────────────────────── */}
      {loading ? (
        <div className="flex items-center justify-center h-64">
          <div className="text-center">
            <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600 mx-auto mb-3" />
            <p className="text-sm text-gray-400">Cargando menús...</p>
          </div>
        </div>
      ) : error ? (
        <div className="bg-white border border-red-200 rounded-lg p-4 flex gap-3">
          <AlertCircle className="w-5 h-5 text-red-500 shrink-0 mt-0.5" />
          <p className="text-sm text-red-700">{error}</p>
        </div>
      ) : (
        <>
          {tab === 'admin'    && <AdminMenus menus={menus} onRefresh={loadMenus} />}
          {tab === 'empleado' && <EmpleadoMenu />}
          {tab === 'reporte'  && <ReporteCafeteria menus={menus} />}
        </>
      )}
    </div>
  );
}
